// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  masRetailPrivateProcessing: 'https://managed-accounts-private-transaction-service-dev.apps.nwie.net/api',
  // masRetailPrivateProcessing: 'http://localhost:8080/api',
  trustArcUrl: 'http://localhost.nwie.net/privacy-policy/online-privacy-policy'
};
